/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { normalized } from "src/utils/global";

class Role {
  constructor() {
  }

  public getRoleModel(request:any) {
    let requestData = normalized(request);
    let roleModel:any = {
      roleId: requestData?.roleid,
      roleName: requestData?.rolename,
      roleAlias: requestData?.rolealias,
      canEdit: requestData?.canedit,
      canDelete: requestData?.candelete,
      permissions: requestData?.permissions?.map((resource:any) => {
        return {
          resourceId: resource?.resourceid,
          actionIds: resource?.actionids,
        }
      })
    }
    return roleModel;
  }

  public getListRoleModel(request:any) {
    let requestData = normalized(request);
    let listRoleModel:any = requestData?.roles?.map((rol:any) => {
      return this.getRoleModel(rol);
    })
    return listRoleModel;
  }
}

export default Role;